import { render, staticRenderFns } from "./_TodoActionsKanban.vue?vue&type=template&id=12fd87f4&scoped=true&"
import script from "./_TodoActionsKanban.vue?vue&type=script&lang=js&"
export * from "./_TodoActionsKanban.vue?vue&type=script&lang=js&"
import style0 from "./_TodoActionsKanban.vue?vue&type=style&index=0&id=12fd87f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd87f4",
  null
  
)

export default component.exports